export default function Skeleton() {
  return <div className='homepage-container absolute left-0 top-0 h-[172px] w-full lg:h-[216px]' data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            <div className='flex h-full w-full items-center justify-between bg-white py-3'>
                <div className='h-full w-[5%] animate-pulse rounded-l bg-gray-100 lg:w-[28%]'></div>
                <div className='h-full w-[85%] animate-pulse rounded bg-gray-100 lg:w-[42%]'></div>
                <div className='h-full w-[5%] animate-pulse rounded-r bg-gray-100 lg:w-[28%]'></div>
            </div>
        </div>;
}